<template>
  <generic-view
    :title="$t('scolarship')"
    icon="school"
    v-bind:show_plus="true"
    v-on:add="add"
    :show_refresh="true"
    :header_buttons="header_buttons"
    @refresh="getData"
  >
    <div class="description">
      <div class="ui three cards">
        <div
          class="card"
          v-for="(scolarship, index) in scolarships"
          :key="index"
        >
          <div class="content">
            <div class="header">
              {{ scolarship.std_scolarship_type.name }}
            </div>
            <div class="meta">
              {{ $t("since") }}
              {{
                scolarship.create_date
                  | formatDate(enterprise_setup.simple_date_format)
              }}
            </div>
            <div class="description">
              <pre> {{ scolarship }}</pre>
            </div>
          </div>
          <div class="extra content">
            <a class="right floated star" @click="details(scolarship)">
              <i class="edit icon"></i>
              {{ $t("details") }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in scolarship_modals">
      <component
        :is="mdl"
        :key="index"
        :scolarship_in="selected_scolarship"
        :student_in="$props.student_in"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
      ></component>
    </template>
  </generic-view>
</template>

<script>
import { local_api, error_toast, clone, enterprise_setup } from "@/utils";
import ScolarshipModal from "./scolarship_modal/ScolarshipModal";
import GenericView from "@/components/GenericContainer";
import filters from "@/filters";

export default {
  name: "StudentScolarshipPlugin",
  filters: filters,
  props: {
    module: Object,
    student_in: Object,
  },
  components: {
    "generic-view": GenericView,
  },
  data() {
    return {
      scolarships: [],
      all_scolarships: [],
      scolarship_modals: [],
      selected_scolarship: {},
      header_buttons: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      this.scolarship_modals.push(ScolarshipModal);
    },
    remove(document, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove document?"),
        function() {
          local_api(vm, "post", "/student_document/do-remove", {
            u: document.uuid,
          })
            .then(() => {
              vm.documents.splice(index, 1);
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    destroy() {
      this.scolarship_modals = [];
      this.selected_scolarship = {};
    },
    succedded(/*inscription*/) {
      this.getData();
      // let trgtIdx = this.inscriptions.findIndex(
      //   n => n.uuid == inscription.uuid
      // );
      // if (trgtIdx != -1) this.inscriptions.splice(trgtIdx, 1, inscription);
      // else this.inscriptions.push(inscription);
    },
    filter(/*query*/) {
      // if (query == "") this.inscriptions = this.all_inscriptions;
      // else
      //   this.inscriptions = this.all_inscriptions.filter(
      //     p =>
      //       p.setup &&
      //       (p.setup.name.toUpperCase().includes(query.toUpperCase()) ||
      //         p.setup.description.toUpperCase().includes(query.toUpperCase()) ||
      //         p.setup.files.find(f =>
      //           f.filename.toUpperCase().includes(query.toUpperCase())
      //         ))
      //   );
    },
    getData() {
      let vm = this;
      this.processing = true;

      setTimeout(function() {
        local_api(vm, "post", "/student_scolarship/do-get-list", {
          u: vm.$props.student_in.uuid,
        })
          .then((items) => {
            vm.scolarships = items;
            vm.all_scolarships = clone(items);
            vm.processing = false;
          })
          .catch((err) => {
            error_toast(err);
            console.error(err);
          });
      }, 100);
    },
    details(scolarship) {
      this.selected_scolarship = scolarship;
      this.scolarship_modals.push(ScolarshipModal);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {},
};
</script>
